import React, { useEffect, useRef, useState } from 'react';
import Shared from '../../Components/Frame/Shared';
import * as rsuite from 'rsuite';
import { Table } from 'rsuite';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import DatePicker from "react-datepicker2";
import moment from 'moment-jalaali';
import { MdOutlineSupportAgent } from "react-icons/md";
import * as General from '../../General/General';
import * as Enum from '../../General/Enum';
import TicketMsgProp from '../../Components/Ticket/TicketMsgProp';
import ResponsiveList, { CardTitle, CardField, CardActions } from '../../Components/Shared/ResponsiveList';
import RowHeight from '../../Components/Shared/RowHeight';

const { Column, HeaderCell, Cell } = Table;

// جستجوی تیکت ها - نمای مدیر.
//
// فرق این صفحه با «تیکت ها» (AgentIndex) فقط یک چیز است: آنجا کارتابل
// شخصی است و کارشناس تیکت های خودش را می بیند، اینجا همه تیکت های همه
// شرکت ها، فارغ از اینکه چه کسی رویشان کار کرده. دسترسی را سرور کنترل
// می کند: SearchAll فقط با مجوز مدیر جواب می دهد.
//
// مکالمات هر تیکت با همان TicketMsgProp باز می شود که کارتابل استفاده
// می کند - عمدا کپی تازه ای ساخته نشد.
const Index = () => {

    //#region Const
    let navigate = useNavigate();
    const TicketRef = useRef();

    const [Data, setData] = useState([]);
    const [ShowLoading, setShowLoading] = useState(false);
    const [ShowSearch, setShowSearch] = useState(false);

    //--> فیلترها
    const [CompanyId, setCompanyId] = useState(General.GuidEmpty());
    const [AssignTo, setAssignTo] = useState(General.GuidEmpty());
    const [State, setState] = useState(-1);
    const [Number, setNumber] = useState("");
    const [Title, setTitle] = useState("");

    //--> دامنه این صفحه همه تیکت های همه شرکت هاست؛ باز کردنش با «همه چیز
    //--> از اول» یعنی هر بار انتظار برای چیزی که کسی نخواسته. پیش فرض دو
    //--> روز اخیر است و در خود پنجره جستجو هم دیده می شود، تا معلوم باشد
    //--> چرا فهرست کوتاه است و بشود پاکش کرد.
    const [BeginDate, setBeginDate] = useState(moment().subtract(2, 'days'));
    const [EndDate, setEndDate] = useState(null);

    const [CompanyList, setCompanyList] = useState([]);
    const [UserList, setUserList] = useState([]);
    //#endregion

    //#region Methods

    //--> مقدار ویژه فهرست کارشناس: «انتساب داده نشده».
    //--> نمی شود از Guid.Empty استفاده کرد، چون همان یعنی «همه».
    const UnassignedValue = "unassigned";

    const HandleError = (error) => {
        setShowLoading(false);
        if (error.response) {
            if (error.response.status === 401) {
                navigate("/UnAuthorize");
            }
            else if (error.response.status === 403) {
                navigate("/AccessDenied");
            }
            else {
                General.ShowMsg(Enum.MsgType.error,
                    "خطای " + error.response.status + " در دریافت اطلاعات");
            }
        }
        else {
            General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
        }
    }

    const Bind = () => {
        setShowLoading(true);
        var RequestOption = {
            method: "Get",
            url: General.ApiRoute() + "/Ticket/SearchAll?Title=" + Title,
            headers: {
                ApiKey: process.env.REACT_APP_APIKEY,
                CompanyId: CompanyId,
                //--> سرور Guid می خواهد؛ «بی صاحب ها» با پرچم جدا می آید
                AssignTo: AssignTo === UnassignedValue ? General.GuidEmpty() : AssignTo,
                Unassigned: AssignTo === UnassignedValue,
                State: State,
                Number: Number,
                BeginDate: BeginDate ? BeginDate.format('jYYYY/jMM/jDD') : '',
                EndDate: EndDate ? EndDate.format('jYYYY/jMM/jDD') : ''
            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                setShowLoading(false);
                setShowSearch(false);
                setData(res.data);
            })
            .catch(HandleError)
    }

    const BindCompanies = () => {
        axios({
            method: "Get",
            url: General.ApiRoute() + "/Company/Search?Title=",
            headers: { ApiKey: process.env.REACT_APP_APIKEY },
            withCredentials: true
        })
            .then(function (res) {
                setCompanyList(res.data.map(item => ({
                    label: item.title,
                    value: item.id
                })));
            })
            .catch(() => {
                //--> نبودن فهرست شرکت ها نباید جلوی جستجو را بگیرد
            })
    }

    const BindUsers = () => {
        axios({
            method: "Get",
            url: General.ApiRoute() + "/User/GetAll",
            headers: { ApiKey: process.env.REACT_APP_APIKEY },
            withCredentials: true
        })
            .then(function (res) {
                var list = res.data.map(item => ({
                    label: item.firstName + ' ' + item.lastName,
                    value: item.id
                }));
                list.unshift({ label: "انتساب داده نشده", value: UnassignedValue });
                setUserList(list);
            })
            .catch(() => { })
    }

    const ShowTicketMsg = (Id, TicketNumber) => {
        TicketRef.current.Show(Id, TicketNumber);
    }

    useEffect(() => {
        BindCompanies();
        BindUsers();
        Bind();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    //#endregion

    return (
        <Shared pageTitle={<><MdOutlineSupportAgent size={25} /> جستجوی تیکت ها</>}>

            <div align="left">
                {
                    ShowLoading ?
                        <rsuite.Button appearance="primary" color="green" className="mb-2 ms-2" disabled>
                            <rsuite.Loader content="بازسازی" />
                        </rsuite.Button>
                        :
                        <rsuite.Button appearance="primary" color="green" className="mb-2 ms-2" onClick={Bind}>
                            بازسازی
                        </rsuite.Button>
                }
                {
                    ShowLoading ?
                        <rsuite.Button appearance="primary" className="mb-2 ms-2" disabled>
                            <rsuite.Loader content="جستجو" />
                        </rsuite.Button>
                        :
                        <rsuite.Button appearance="primary" className="mb-2 ms-2" onClick={() => setShowSearch(true)}>
                            جستجو
                        </rsuite.Button>
                }
            </div>
            <rsuite.Divider />

            <ResponsiveList
                fillHeight
                data={Data}
                loading={ShowLoading}
                emptyText="تیکتی یافت نشد"
                filters={[
                    { key: 'number', label: 'شماره', type: 'text' },
                    { key: 'companyTitle', label: 'مشتری', type: 'text' },
                    { key: 'creatorName', label: 'ایجاد کننده', type: 'text' },
                    { key: 'title', label: 'عنوان', type: 'text' },
                    { key: 'assignToFullname', label: 'کارشناس مسئول', type: 'text' },
                    { key: 'stateComment', label: 'وضعیت', type: 'select' }
                ]}
                renderCard={(rowData) => (
                    <>
                        <CardTitle>{rowData.title}</CardTitle>
                        <CardField label="شماره">{rowData.number}</CardField>
                        <CardField label="مشتری">{rowData.companyTitle}</CardField>
                        <CardField label="ثبت کننده">{rowData.creatorName}</CardField>
                        <CardField label="کارشناس مسئول">
                            {
                                rowData.assignToFullname && rowData.assignToFullname.trim() ?
                                    rowData.assignToFullname
                                    :
                                    <rsuite.Tag color="orange">انتساب داده نشده</rsuite.Tag>
                            }
                        </CardField>
                        <CardField label="تاریخ">{rowData.date}</CardField>
                        <CardField label="آخرین به روز رسانی">{rowData.lastUpdateDate}</CardField>
                        <CardField label="وضعیت">{rowData.stateComment}</CardField>
                        <CardActions>
                            <rsuite.Button size="sm" appearance="primary"
                                onClick={() => ShowTicketMsg(rowData.id, rowData.number)}>
                                مکالمات
                            </rsuite.Button>
                        </CardActions>
                    </>
                )}
            >
                <Table
                    rtl={true}
                    className='w-100'
                    bordered
                    headerHeight={40}
                    rowHeight={RowHeight}
                    wordWrap="break-word"
                    data={Data}
                >
                    <Column width={70}>
                        <HeaderCell><b>ردیف</b></HeaderCell>
                        <General.RowNumber />
                    </Column>
                    <Column flexGrow={1}>
                        <HeaderCell><b>شماره</b></HeaderCell>
                        <Cell dataKey="number" />
                    </Column>
                    <Column flexGrow={1}>
                        <HeaderCell><b>تاریخ</b></HeaderCell>
                        <Cell dataKey="date" />
                    </Column>
                    <Column flexGrow={2}>
                        <HeaderCell><b>مشتری</b></HeaderCell>
                        <Cell>
                            {(rowData) => (
                                <>
                                    <div>{rowData.companyTitle}</div>
                                    <div style={{ color: '#8c97a3', fontSize: 11 }}>
                                        {rowData.creatorName}
                                    </div>
                                </>
                            )}
                        </Cell>
                    </Column>
                    <Column flexGrow={3}>
                        {/* عنوان پیوند است، چون کاری که در این صفحه انجام
                            می شود دیدن مکالمات همان تیکت است */}
                        <HeaderCell><b>عنوان</b></HeaderCell>
                        <Cell>
                            {(rowData) => (
                                <span className='HandCursor' style={{ color: '#2a78d6' }}
                                    onClick={() => ShowTicketMsg(rowData.id, rowData.number)}>
                                    {rowData.title}
                                </span>
                            )}
                        </Cell>
                    </Column>
                    <Column flexGrow={2}>
                        <HeaderCell><b>کارشناس مسئول</b></HeaderCell>
                        <Cell>
                            {(rowData) => (
                                rowData.assignToFullname && rowData.assignToFullname.trim() ?
                                    <span>{rowData.assignToFullname}</span>
                                    :
                                    <rsuite.Tag color="orange">انتساب داده نشده</rsuite.Tag>
                            )}
                        </Cell>
                    </Column>
                    <Column flexGrow={1}>
                        <HeaderCell><b>آخرین به روز رسانی</b></HeaderCell>
                        <Cell dataKey="lastUpdateDate" />
                    </Column>
                    <Column flexGrow={1}>
                        <HeaderCell><b>وضعیت</b></HeaderCell>
                        <Cell dataKey="stateComment" />
                    </Column>
                    <Column width={110} fixed="right">
                        <HeaderCell><b>عملیات</b></HeaderCell>
                        <Cell>
                            {(rowData) => (
                                <rsuite.Button size="sm" appearance="primary"
                                    onClick={() => ShowTicketMsg(rowData.id, rowData.number)}>
                                    مکالمات
                                </rsuite.Button>
                            )}
                        </Cell>
                    </Column>
                </Table>
            </ResponsiveList>

            <rsuite.Drawer open={ShowSearch} onClose={() => setShowSearch(false)}
                placement={isMobile ? 'bottom' : 'right'} size={isMobile ? 'full' : 'sm'}>
                <rsuite.Drawer.Header>
                    <rsuite.Drawer.Title>جستجو</rsuite.Drawer.Title>
                    <rsuite.Drawer.Actions>
                        {
                            ShowLoading ?
                                <rsuite.Button appearance='primary' disabled>
                                    <rsuite.Loader content="جستجو" />
                                </rsuite.Button>
                                :
                                <rsuite.Button appearance='primary' onClick={Bind}>جستجو</rsuite.Button>
                        }
                    </rsuite.Drawer.Actions>
                </rsuite.Drawer.Header>
                <rsuite.Drawer.Body>
                    <div className='mb-2'>
                        <label>مشتری</label>
                        <rsuite.SelectPicker
                            data={CompanyList}
                            value={CompanyId === General.GuidEmpty() ? null : CompanyId}
                            onChange={value => setCompanyId(value ? value : General.GuidEmpty())}
                            onClean={() => setCompanyId(General.GuidEmpty())}
                            className="w-100"
                            placeholder="همه مشتری ها"
                        />
                    </div>
                    <div className='mb-2'>
                        <label>کارشناس مسئول</label>
                        <rsuite.SelectPicker
                            data={UserList}
                            value={AssignTo === General.GuidEmpty() ? null : AssignTo}
                            onChange={value => setAssignTo(value ? value : General.GuidEmpty())}
                            onClean={() => setAssignTo(General.GuidEmpty())}
                            className="w-100"
                            placeholder="همه کارشناس ها"
                        />
                    </div>
                    <div className='mb-2'>
                        <label>شماره تیکت</label>
                        <rsuite.Input className='w-100' value={Number}
                            onChange={value => setNumber(value)} />
                    </div>
                    <div className='mb-2'>
                        <label>عنوان</label>
                        <rsuite.Input className='w-100' value={Title}
                            onChange={value => setTitle(value)} />
                    </div>
                    <div className='mb-2'>
                        <label>وضعیت</label>
                        <rsuite.SelectPicker
                            searchable={false}
                            data={[
                                { label: "تمام تیکت ها", value: -1 },
                                { label: "ثبت اولیه", value: 0 },
                                { label: "در دست بررسی", value: 1 },
                                { label: "پاسخ داده شده", value: 2 },
                                { label: "بسته شده", value: 3 },
                                { label: "در صف انتظار", value: 4 }
                            ]}
                            value={State}
                            onChange={value => setState(value === null ? -1 : value)}
                            onClean={() => setState(-1)}
                            className="w-100"
                            placeholder="انتخاب کنید"
                        />
                    </div>
                    <div className='mb-2'>
                        <label>از تاریخ</label>
                        <DatePicker className="form-control" isGregorian={false} timePicker={false}
                            value={BeginDate} inputJalaaliFormat='jYYYY/jMM/jDD'
                            onChange={(value) => setBeginDate(value)} />
                    </div>
                    <div className='mb-2'>
                        <label>تا تاریخ</label>
                        <DatePicker className="form-control" isGregorian={false} timePicker={false}
                            value={EndDate} inputJalaaliFormat='jYYYY/jMM/jDD'
                            onChange={(value) => setEndDate(value)} />
                    </div>
                </rsuite.Drawer.Body>
            </rsuite.Drawer>

            {/* فقط خواندنی: اینجا جای مرور سابقه است نه رسیدگی. رسیدگی در
                کارتابل انجام می شود، جایی که تیکت به کارشناسش سپرده شده. */}
            <TicketMsgProp ref={TicketRef} readOnly />

        </Shared>
    );
}

export default Index;
